import { setStudioConfig } from "util/studio-config";
export default () => (next) => (action) => {
    if (action.type === "CONNECT" && "error" in action && !action.error) {
        const state = action.payload;
        if (state.primaryConnection && state.primaryConnection.config) {
            const { user, password, clusterId, kerberosAutoLogin, } = state.primaryConnection.config;
            let autoLogin;
            if (password === "") {
                autoLogin = {
                    username: user,
                    password,
                    kerberosAutoLogin,
                };
            }
            setStudioConfig((oldConfig) => ({
                clusters: {
                    ...oldConfig.clusters,
                    [clusterId]: {
                        ...oldConfig.clusters[clusterId],
                        autoLogin,
                    },
                },
            }));
        }
    }
    return next(action);
};
